import React from "react";
import Profile from "../components/Profile";

export default function MyProfile() {
  const {profileData} = Profile();
  
  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
          <h2 className="pill">My Profile</h2>
        </div>
        <div className="card-body">
          <table className="table">
            <tbody>
              <tr>
                <td><strong>Name</strong></td>
                <td>{profileData.name}</td>
              </tr>
              <tr>
                <td><strong>Email</strong></td>
                <td>{profileData.email}</td>
              </tr>
              <tr>
                <td><strong>Phone</strong></td>
                <td>{profileData.phoneNumber}</td>
              </tr>
              <tr>
                <td><strong>Username</strong></td>
                <td>{profileData.username}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
